module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kh-ffda5c64882c0293dab053442c4a1db0.svg";